const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class TripleCta extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (window.BAO.MediaBreakpoints.isMd) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('triple-cta')) {
  customElements.define('triple-cta', TripleCta)
}
